<template>
  <div
    class="absolute inset-x-0 bottom-0 z-[5]"
    :style="{top: `${offsetTop}px`}"
  >
    <core-state-layout>
      <slot />
    </core-state-layout>
  </div>
</template>

<script setup>
  const props = defineProps({
    container: Object,
    boundary: Object
  });

  const {top: containerTop, height: containerHeight} = useElementBounding(() => props.container);
  const {bottom: boundaryBottom, update: updateBoundary} = useElementBounding(() => props.boundary);
  // Keep caller headers and mounted filter controls outside the empty pane without changing the virtual grid.
  useResizeObserver(() => [
    props.boundary?.previousElementSibling,
    props.boundary?.parentElement?.firstElementChild
  ].filter(Boolean), updateBoundary);
  useMutationObserver(() => props.container, updateBoundary, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class', 'style']
  });
  watch([containerTop, containerHeight], updateBoundary);
  const offsetTop = computed(() => (
    props.boundary
      ? Math.min(containerHeight.value, Math.max(0, boundaryBottom.value - containerTop.value))
      : 0
  ));
</script>
